module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.text === false) ? _c('b-button-group', [_c('b-button', {
    attrs: {
      "variant": _vm.onVariant,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.setValue(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.on))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": _vm.offVariant,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.setValue(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.off))])], 1) : _c('span', [_vm._v(_vm._s(_vm.textValue))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf705dca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleButton.vue
// module id = 2149
// module chunks = 1